"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

var _utils = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(_class, _Component);

    function _class(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.state = {
        value: props.value
      };
      _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = _class.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.convertValue(this.props.value);
    };

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
      var options = {
        deep: ['defaultValue', 'name', 'value']
      };
      return !((0, _shallowEqual.default)(nextProps, this.props, options) && (0, _shallowEqual.default)(nextState, this.state, options));
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (!(0, _shallowEqual.default)(prevProps.value, value) && !(0, _shallowEqual.default)(value, this.state.value)) {
        this.convertValue(value);
      }
    };

    _proto.getFormat = function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          type = _this$props.type;
      if (format) return format;

      switch (type) {
        case 'datetime':
          return 'yyyy-MM-dd HH:mm:ss';

        case 'month':
          return 'yyyy-MM';

        case 'time':
          return 'HH:mm:ss';

        case 'week':
          return 'yyyy WW';

        default:
          return 'yyyy-MM-dd';
      }
    };

    _proto.convertValue = function convertValue(value) {
      var range = this.props.range;

      if (!value) {
        this.setState({
          value: value
        });
        return undefined;
      }

      var format = this.getFormat();

      if (!range) {
        var _newValue = _utils.default.format(_utils.default.toDateWithFormat(value, format, undefined), format);

        if (_newValue !== value) this.props.onChange(_newValue);else if (_newValue !== this.state.value) this.setState({
          value: _newValue
        });
        return _newValue;
      }

      var newValue = value.map(function (v) {
        if (!v) return undefined;
        return _utils.default.format(_utils.default.toDateWithFormat(v, format, undefined), format);
      });

      if (!(0, _shallowEqual.default)(newValue, value)) {
        this.props.onChange(newValue);
      } else if (!(0, _shallowEqual.default)(newValue, this.state.value)) {
        this.setState({
          value: newValue
        });
        return newValue;
      }

      if ((0, _shallowEqual.default)(newValue, [undefined, undefined])) {
        this.setState({
          value: newValue
        });
      } else {
        this.state.value = newValue;
      }

      return newValue;
    };

    _proto.handleChange = function handleChange(value, callback) {
      this.setState({
        value: value
      }, callback);
    };

    _proto.handleBlur = function handleBlur() {
      this.props.onChange(this.state.value);
    };

    _proto.render = function render() {
      var value = this.state.value;
      return _react.default.createElement(Origin, _extends({}, this.props, {
        onChange: this.handleChange,
        onValueBlur: this.handleBlur,
        onBlur: this.props.onBlur,
        value: value
      }));
    };

    return _class;
  }(_react.Component), _defineProperty(_class, "propTypes", {
    format: _propTypes.default.string,
    onBlur: _propTypes.default.func,
    onChange: _propTypes.default.func,
    range: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
    type: _propTypes.default.string,
    value: _propTypes.default.any
  }), _temp;
};

exports.default = _default;